var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'show': _vm.show },attrs:{"id":"shortcut-overlay"}},_vm._l((_vm.shortcutHints),function(hint){return _c('shortcut-overlay-item',{key:hint.modalGuid,attrs:{"shortcutHint":hint,"show":_vm.show}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ece07b4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/home/_components/tombola-shortcut-overlay/tombola-shortcut-overlay.html
// module id = null
// module chunks = 